import { render } from "./Login.vue?vue&type=template&id=06cb2c3c"
import script from "../controllers/loginCtrl.js?vue&type=script&lang=js"
export * from "../controllers/loginCtrl.js?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=06cb2c3c&lang=css"

import exportComponent from "C:\\Users\\Desarrollo\\Documents\\Inventarios 2.0\\Technosoft.Inventarios.v2\\Technosoft.Inventarios.v2.UI.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__